import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dumbbell, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Şifreniz güncellendi. Giriş yapabilirsiniz.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary text-primary-foreground">
            <Dumbbell className="h-6 w-6" />
          </div>
          <p className="font-heading text-xl font-extrabold tracking-tight">FIT HOUSE</p>
        </div>
        <h1 className="font-heading text-2xl font-bold">Yeni Şifre Belirle</h1>
        <p className="mb-6 mt-1 text-sm text-muted-foreground">Hesabınız için yeni bir şifre girin.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="password">Yeni Şifre</Label>
            <Input id="password" data-testid="reset-password" type="password" value={password}
              onChange={(e) => setPassword(e.target.value)} className="mt-1.5" required minLength={6} />
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <Button data-testid="reset-submit" type="submit" disabled={loading || !token} className="w-full font-semibold">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Şifreyi Güncelle
          </Button>
        </form>
        <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm text-primary hover:underline">
          <ArrowLeft className="h-4 w-4" /> Girişe dön
        </Link>
      </div>
    </div>
  );
}
